/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The content to render within the component.
   * Typically a `TableTh` or `TableTd` component.
   */
  children: React.ReactNode;
};

const Styles = labelStyles('TableRow', {
  root: css`
    display: table-row;
  `,
});

/**
 * The `tr` tag; use to group data into rows.
 */
export const TableRow = (props: Props) => {
  return (
    <tr css={Styles.root} role="row">
      {props.children}
    </tr>
  );
};
